import baseTheme from "@/themes/baseTheme";
import { ThemeConfig } from "antd";

const testTheme: ThemeConfig = {
  ...baseTheme,
  token: {
    ...baseTheme.token,
    colorBgLayout: "#FEE7AA",
  },
};

export default testTheme;
